document.addEventListener('DOMContentLoaded', function() {
  // Create audio element with your sound file
  const menuSound = new Audio('https://cdn.shopify.com/s/files/1/0078/8945/3133/files/Menu_slide_sound_FX.mp3?v=1760599239');
  
  // Set volume (0.0 to 1.0, where 1.0 is 100%)
  menuSound.volume = 0.3;  // This sets it to 30% volume
  
  // Find your menu button using the correct class
  const menuButton = document.querySelector('.menu-icon-open');
  
  if (menuButton) {
    menuButton.addEventListener('click', function() {
      menuSound.play().catch(e => console.log('Audio play failed:', e));
    });
  }
});


